import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { NotesIcon } from "assets";
import { useNotify } from "hooks";
import { getScorecardDataCellDetails } from "api";
import { NotesModal } from "../../modals";

interface NotesActionButtonProps {
    dataId: number;
    initialNotes?: string;
    hasNotes?: boolean;
    disabled?: boolean;
}

export const NotesActionButton: React.FC<NotesActionButtonProps> = ({
    dataId,
    initialNotes = "",
    hasNotes = false,
    disabled = false,
}) => {
    const notify = useNotify();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [notes, setNotes] = useState(initialNotes);

    const handleOpenModal = async () => {
        if (hasNotes) {
            try {
                const cellDetails = await getScorecardDataCellDetails(dataId);
                setNotes(cellDetails.notes);
            } catch (error: any) {
                notify.error(error?.response?.data || 'Failed to fetch cell details:');
                setNotes(initialNotes);
            }
        }
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Tooltip arrow placement="top" title="Notes">
                <IconButton
                    sx={{
                        width: "20px",
                        height: "20px",
                        padding: 0,
                        "&:hover": {
                            backgroundColor: "rgba(5, 66, 84, 0.1)",
                        },
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleOpenModal();
                    }}
                    disabled={disabled}
                >
                    <NotesIcon
                        color={disabled ? "#9CA3AF" : (hasNotes ? "#46A314" : "#054254")}
                        style={{
                            width: "16px",
                            height: "16px",
                        }}
                    />
                </IconButton>
            </Tooltip>

            {isModalOpen && !!dataId && (
                <NotesModal
                    open={isModalOpen}
                    onClose={handleCloseModal}
                    initialNotes={notes}
                    dataId={dataId}
                />
            )}
        </>
    );
};
